import { useState } from 'react';
import './SubModal.css';
import * as Yup from 'yup';
import Form from '../../../components/form/components/Form/Form';
import FormField from '../../../components/form/components/FormField/FormField';
import Button from '../../../components/form/components/Button/Button';
import ErrorMessage from '../../../components/form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection,query, where, getDocs,setDoc, addDoc, getDoc, updateDoc, serverTimestamp, arrayUnion   } from "firebase/firestore"; 

import { Timestamp } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const initialValues= {
  phone: null,
  length: null,
  date:  null
}

const override = {
    marginTop: '20px'
  };


function ReadingsModal({ onClose, onContentAdded, activeCaseData } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    const [user] = useAuthState(auth);
    const [gender, setGender] = useState('');

    const [description, setDescription] = useState("");


    const validationSchema = Yup.object().shape({
        phone: Yup.string().min(9, 'Must be at least  9 digits').max(9, 'Must be 9 digits').required('Phone is required'),
        length: Yup.number().required("Subscription Length  Is Required"),
    })

    // NEW VALS

    const calculateDateForMonths = (startDate: any, months: any) => {
      // Split the start date into year, month, and day components
      const [startYear, startMonth, startDay] = startDate.split('-');
      
      // Create a new Date object using the start date components
      const startDateObject = new Date(startYear, startMonth - 1, startDay);
      
      // Calculate the target date by adding the specified number of months
      const targetDate = new Date(startDateObject.getFullYear(), startDateObject.getMonth() + months, startDateObject.getDate());
      
      // Format the target date as YYYY-MM-DD
      const formattedDate: any = targetDate.toISOString().split('T')[0];

      return new Date(formattedDate);
    };

    const handleSubmitData = async (values: any) => {
            // console.log('VALS:  ',  values);

            let expDate = calculateDateForMonths(values.date, Number(values.length));
            // console.log('DATE RES: ', expDate);


            setLoading(true);

            let planValidityDays = 0;

            if(Number(values.length) == 1) {
              planValidityDays = 30
            }else if(Number(values.length) == 2) {
              planValidityDays = 60
            }else if(Number(values.length) == 3) {
              planValidityDays = 90
            }else if(Number(values.length) == 4) {
              planValidityDays = 120
            }else if(Number(values.length) == 5) {
              planValidityDays = 150
            }else if(Number(values.length) == 6) {
              planValidityDays = 180
            }else if(Number(values.length) == 7) {
              planValidityDays = 210
            }else if(Number(values.length) == 8) {
              planValidityDays = 240
            }else if(Number(values.length) == 9) {
              planValidityDays = 270
            }else if(Number(values.length) == 10) {
              planValidityDays = 300
            }else if(Number(values.length) == 11) {
              planValidityDays = 330
            }else if(Number(values.length) == 12) {
              planValidityDays = 360
            }

            // var expireDate = new Date()
            // expireDate.setDate(expireDate.getDate() + planValidityDays)
            const currentTimestamp = serverTimestamp();

          

            const q1 = query(collection(db, "Patients"), 
            where("phoneNumber", "==", `+237${values.phone}`));

            const querySnapshot1 = await getDocs(q1);

            if(querySnapshot1.empty) {  
              toast.error("Patient Does Not Exist", {
                pauseOnHover: false,
                closeOnClick: true,
              });

              setLoading(false);
              return;
            }
            
            // console.log('PATIENT DATA: ',  querySnapshot1.docs[0]?.data().uid);
            // querySnapshot1.docs.forEach(data => {
            //   console.log('P DATA: ', data.data())
            // })

            let patientId = querySnapshot1.docs[0]?.data().uid;
            
            const q2 = query(collection(db, "Subscriptions"), 
            where("user_id", "==", patientId),
            where("isActive", "==", true));


            const querySnapshot2 = await getDocs(q2);

            if(!querySnapshot2.empty) {  
              toast.error("Patient Has An Active Subscription", {
                pauseOnHover: false,
                closeOnClick: true,
              });

              setLoading(false);
              return;
            }


            let userId = querySnapshot1.docs[0]?.data().uid;

            let subData  =  {
              plan_id: null,
              end_date: expDate,
              isActive: true,
              user_id: userId,
              amount: null,
              patient_phone: `+237${values.phone}`,
              plan_length: Number(values.length),
              createdAt: currentTimestamp
          }


          const subscriptionRef = collection(db, "Subscriptions");

          await addDoc(subscriptionRef, subData);

            toast.success("Subscription created successfully", {
              pauseOnHover: false,
              closeOnClick: true,
            });

            setLoading(false);
            onContentAdded();
            onClose();
            // return;
    }



    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="reports-modal">
                <div className='modal-head'>
                    <p className="modal-title">Subscriber Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitData}
                    validationSchema={validationSchema}
                >
    
                  <p className="label-text">Patient's Phone: </p>
                <FormField  name="phone" type="text" placeholder="Enter Patient's Phone"/>

                    <br />

                    <p className="label-text">Length: </p>
                    <FormField
                      name="length"
                      type="number"
                      placeholder="Subscription Length"
                    />

                    <br />
                    <p className="label-text">Date: </p>
                    <FormField
                      name="date"
                      type="date"
                      //   placeholder="Date of Birth"
                      />

                      {!loading && <Button isOutLined={true} isFullWidth={false} title="SUBMIT DATA"/>}

                        </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default ReadingsModal;



